<template>
  <div style="font-family: 'Nunito Sans', sans-serif">
    <div class="contact-wrapper">
      <v-container class="contact-section py-8" fluid>
        <div class="orange-cut orange-cut-1"></div>
        <div class="orange-cut orange-cut-2"></div>
        <div class="orange-cut orange-cut-3"></div>

        <v-row justify="center" align="center" class="ma-0 relative-z">
          <v-col cols="12" md="5" class="text-center text-md-right pr-md-6 mb-6 mb-md-0">
            <h2 class="section-heading">GET IN TOUCH</h2>
            <p class="section-subheading">We're here to help you anytime</p>
          </v-col>

          <v-col cols="12" md="6" class="text-center text-md-left">
            <v-card class="unified-contact-bar" flat>
              <div class="d-flex flex-wrap justify-center align-center py-4 px-6">
                <div class="contact-item">
                  <v-icon color="#ff6600" class="mr-2">mdi-phone-in-talk</v-icon>

                  <span
                    class="contact-link"
                    style="cursor: pointer"
                    @click="openWhatsApp('+91 735 6449 135')"
                  >
                    +91 735 6449 135
                  </span>

                  <span class="status-dot"></span>
                  <span class="availability">24/7</span>
                </div>

                <v-divider vertical class="mx-4 d-none d-sm-block"></v-divider>
                <div class="contact-item">
                  <v-icon color="#ff6600" class="mr-2">mdi-email</v-icon>
                  <a href="mailto:support@ohyesworld.com" class="contact-link bigger-email"
                    >support@ohyesworld.com</a
                  >
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" lg="11" class="mt-8">
            <v-row justify="center">
              <v-col v-for="(office, i) in offices" :key="i" cols="12" sm="4" class="py-2">
                <v-card class="office-card-compact" flat>
                  <div class="d-flex align-center mb-2">
                    <div class="city-dot"></div>
                    <h4 class="office-city">{{ office.city }}</h4>
                  </div>
                  <p class="office-address-text">
                    {{ office.address.join(' ') }}
                  </p>
                  <div
                    v-if="office.phone"
                    class="office-tel-mini mt-1"
                    style="cursor: pointer"
                    @click="openWhatsApp(office.phone)"
                  >
                    <v-icon size="12" color="#ff6600">mdi-phone</v-icon>
                    {{ office.phone }}
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-footer ref="appFooter" padless color="orange darken-3" dark>
      <v-container class="py-8">
        <v-divider color="white" class="mb-6 opacity-50"></v-divider>

        <div class="text-center mb-6">
          <v-btn
            v-for="icon in socialLinks"
            :key="icon.name"
            :href="icon.link"
            target="_blank"
            rel="noopener"
            class="mx-2 social-btn"
            fab
            small
          >
            <v-icon size="20">{{ icon.icon }}</v-icon>
          </v-btn>
        </div>

        <div class="footer-text text-center">
          <p class="brand-name mb-1">© Oh Yes. All rights reserved.</p>
          <p class="website mb-0">www.ohyesworld.com</p>
        </div>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      offices: [
        {
          city: 'BENGALURU',
          address: ['Second floor, INQ Innovation, 59, 100 Feet Rd, Indiranagar, KA 560038'],
          phone: '+91 735 6449 135',
        },
        {
          city: 'CHICAGO',
          address: ['1645 S River Rd, Unit 3, Des Plaines, IL 60018, USA'],
          phone: '+1 708-295-3912',
        },
        {
          city: 'KOCHI',
          address: ['Oh Yes Home Solutions, 2nd floor, Angamaly, Kerala 683572'],
          phone: '+91 735 6449 135',
        },
      ],
      socialLinks: [
        {
          name: 'App Store',
          icon: 'mdi-apple',
          link: 'https://apps.apple.com/in/app/oh-yes-home-solution/id6471665769',
        },
        {
          name: 'Google Play',
          icon: 'mdi-google-play',
          link: 'https://play.google.com/store/apps/details?id=com.ohyes.app',
        },
        { name: 'Facebook', icon: 'mdi-facebook', link: 'https://www.facebook.com/ohyeservices' },
        {
          name: 'LinkedIn',
          icon: 'mdi-linkedin',
          link: 'https://www.linkedin.com/company/oh-yes-world-app',
        },
        { name: 'YouTube', icon: 'mdi-youtube', link: 'https://www.youtube.com/@ohyesappIndia' },
        {
          name: 'Instagram',
          icon: 'mdi-instagram',
          link: 'https://www.instagram.com/ohyesappindia/',
        },
      ],
    };
  },
  methods: {
    openWhatsApp(phone) {
      if (!phone) return;

      // remove spaces, +, and dashes
      const cleanNumber = phone.replace(/[^\d]/g, '');

      // optional prefilled message
      const message = encodeURIComponent('Hello, I need support');

      const url = `https://wa.me/${cleanNumber}?text=${message}`;

      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;500;600;700;800;900&display=swap');

.contact-wrapper {
  background: #ffffff;
  position: relative;
  overflow: hidden;
  min-height: 45vh;
  display: flex;
  align-items: center;
  font-family: 'Nunito Sans', sans-serif;
}

.relative-z {
  position: relative;
  z-index: 5;
}

/* ===== DECORATIVE BACKGROUND ===== */
.orange-cut {
  position: absolute;
  z-index: 1;
}
.orange-cut-1 {
  width: 400px;
  height: 400px;
  background: linear-gradient(135deg, rgba(255, 102, 0, 0.08) 0%, rgba(255, 152, 0, 0.12) 100%);
  border-radius: 50%;
  top: -200px;
  left: -100px;
  filter: blur(60px);
}
.orange-cut-2 {
  width: 500px;
  height: 500px;
  background: linear-gradient(225deg, rgba(255, 87, 34, 0.1) 0%, rgba(255, 152, 0, 0.06) 100%);
  border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
  bottom: -250px;
  right: -150px;
  animation: morph 8s ease-in-out infinite;
}
.orange-cut-3 {
  width: 300px;
  height: 300px;
  background: linear-gradient(180deg, rgba(255, 102, 0, 0.06) 0%, rgba(230, 81, 0, 0.08) 100%);
  border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  filter: blur(80px);
  animation: float 6s ease-in-out infinite;
}

@keyframes morph {
  0%,
  100% {
    border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
  }
  50% {
    border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
  }
}
@keyframes float {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -45%) scale(1.1);
  }
}

/* ===== TYPOGRAPHY ===== */
.section-heading {
  font-weight: 900;
  font-size: 2.8rem;
  color: #e65100;
  text-transform: uppercase;
  line-height: 1.1;
  margin-bottom: 8px;
}
.section-subheading {
  font-size: 1.1rem;
  color: #555;
  font-weight: 600;
}

/* ===== CONTACT BAR ===== */
.unified-contact-bar {
  background: #ffffff !important;
  border-radius: 24px !important;
  border: 2px solid rgba(255, 102, 0, 0.3) !important;
  box-shadow: 0 10px 40px rgba(255, 102, 0, 0.15) !important;
}
.contact-item {
  display: flex;
  align-items: center;
}
.contact-link {
  font-weight: 800;
  font-size: 1.2rem;
  color: #333;
  text-decoration: none;
  transition: color 0.3s ease;
}
.contact-link:hover {
  color: #ff6600;
}
.bigger-email {
  color: #e65100;
  font-size: 1.25rem;
}

.status-dot {
  width: 8px;
  height: 8px;
  background: #4caf50;
  border-radius: 50%;
  margin: 0 10px;
}
.availability {
  font-size: 0.8rem;
  font-weight: 900;
  color: #4caf50;
  text-transform: uppercase;
}

/* ===== OFFICE CARDS ===== */
.office-card-compact {
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.7) !important;
  border-radius: 16px !important;
  border: 1px solid #f0f0f0 !important;
  height: 100%;
  transition: all 0.3s ease;
}
.office-card-compact:hover {
  border-color: #ff6600;
  transform: translateY(-3px);
}
.city-dot {
  width: 8px;
  height: 8px;
  background: #ff6600;
  border-radius: 2px;
  margin-right: 10px;
}
.office-city {
  font-weight: 900;
  color: #333;
  font-size: 1rem;
}
.office-address-text {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.4;
  margin-bottom: 0 !important;
}
.office-tel-mini {
  font-size: 0.9rem;
  font-weight: 800;
  color: #ff6600;
}

/* ===== FOOTER ===== */
.v-footer {
  background: linear-gradient(135deg, #e64a19 0%, #f57c00 100%) !important;
}
.social-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.2);
}
.social-btn:hover {
  background: white !important;
  color: #ff6600 !important;
  transform: translateY(-4px);
}
.brand-name {
  font-weight: 700;
  font-size: 1.05rem;
}
.website {
  color: #ffcc80;
  font-weight: 600;
}

@media (max-width: 960px) {
  .section-heading {
    font-size: 2.2rem;
  }
  .unified-contact-bar {
    border-radius: 16px !important;
  }
}
</style>